import { useContext } from 'react';
import { BreadcrumbContext } from '../components/navigation/BreadcrumbContext';

export function useBreadcrumbs() {
  return useContext(BreadcrumbContext);
}
